<script setup>
import { computed } from 'vue'

const MAX_SEGMENTS = 12

const props = defineProps({
  progress: {
    type: Object,
    required: true,
  },
  dense: {
    type: Boolean,
    default: false,
  },
  circular: {
    type: Boolean,
    default: false,
  },
})

const ratio = computed(() => (props.progress.total ? props.progress.done / props.progress.total : 0))
</script>

<template>
  <q-circular-progress
    v-if="circular"
    show-value
    :value="ratio * 100"
    size="2.25rem"
    :thickness="0.18"
    color="primary"
    track-color="grey-3"
    font-size=".625rem"
    class="text-weight-medium"
  >
    {{ progress.done }}/{{ progress.total }}
  </q-circular-progress>
  <div v-else-if="progress.total" class="task-progress row no-wrap items-center" :class="{ 'q-px-md q-pb-sm': !dense }">
    <template v-if="progress.total <= MAX_SEGMENTS">
      <div
        v-for="index in progress.total"
        :key="index"
        class="task-progress__segment col"
        :class="{ 'task-progress__segment--done': index <= progress.done }"
      />
    </template>
    <q-linear-progress
      v-else
      class="col"
      rounded
      :value="ratio"
    />
  </div>
</template>

<style scoped>
.task-progress {
  gap: .125rem;
}

.task-progress__segment {
  height: .25rem;
  border-radius: .125rem;
  background-color: color-mix(in srgb, var(--q-primary) 15%, transparent);
}

.task-progress__segment--done {
  background-color: var(--q-primary);
}
</style>
